import { render, staticRenderFns } from "./fakeTransactionsList.vue?vue&type=template&id=4323d26b&scoped=true&"
import script from "./fakeTransactionsList.vue?vue&type=script&lang=js&"
export * from "./fakeTransactionsList.vue?vue&type=script&lang=js&"
import style0 from "./fakeTransactionsList.vue?vue&type=style&index=0&id=4323d26b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4323d26b",
  null
  
)

export default component.exports